import React from "react";
export const CallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M6.3478 4.8825C6.442 4.7883 6.4891 4.7412 6.53059 4.70308C7.5508 3.76564 9.11894 3.76564 10.1392 4.70308C10.1806 4.7412 10.2277 4.7883 10.3219 4.8825L12.2662 6.82676C13.3356 7.89616 13.6414 9.51114 13.0371 10.8975C12.4328 12.2839 12.7387 13.8989 13.8081 14.9683L17.0038 18.164C18.0732 19.2334 19.6882 19.5393 21.0746 18.935C22.461 18.3306 24.0759 18.6365 25.1453 19.7059L27.0896 21.6502C27.1838 21.7444 27.2309 21.7915 27.269 21.8329C28.2065 22.8532 28.2065 24.4213 27.269 25.4415C27.2309 25.483 27.1838 25.5301 27.0896 25.6243L25.9078 26.8061C24.9454 27.7685 23.558 28.1725 22.2294 27.8772C13.1766 25.8655 6.1066 18.7955 4.09487 9.74267C3.79962 8.41405 4.20362 7.02668 5.16601 6.06429L6.3478 4.8825Z"
        stroke="#1A1A1B"
        strokeWidth={"1.5"}
      />
    </svg>
  );
};
